import { Accordion, AccordionTab } from "primereact/accordion";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { formatDateStandard } from "../../../shared/utility";

export default function ExpiredItemsAccordion({ expiredOrderItems }) {
  if (!expiredOrderItems || expiredOrderItems.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <Accordion className="bg-yellow-50 border-l-4 border-yellow-400 rounded-md">
        <AccordionTab
          header={
            <div className="flex items-center gap-2">
              <ExclamationTriangleIcon className="h-5 w-5 text-yellow-500" />
              <span className="font-medium text-gray-900">
                Warning: {expiredOrderItems.length} Expired Item
                {expiredOrderItems.length !== 1 ? "s" : ""} in Shipment
              </span>
            </div>
          }
          headerClassName="bg-yellow-50 text-yellow-800"
          contentClassName="bg-yellow-50 p-4"
        >
          <div className="space-y-4">
            {expiredOrderItems.map((item, index) => (
              <div
                key={`${item.packaging_id}-${index}`}
                className="grid grid-cols-2 gap-4 pb-4 border-b border-gray-200 last:border-b-0 last:pb-0"
              >
                <div>
                  <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">
                    Serial Number
                  </span>
                  <p className="mt-1 text-sm font-semibold text-gray-900">
                    {item.serial_number}
                  </p>
                </div>
                <div>
                  <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">
                    Product
                  </span>
                  <p className="mt-1 text-sm text-gray-900">
                    {item.product_name}
                  </p>
                </div>
                <div>
                  <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">
                    Lot
                  </span>
                  <p className="mt-1 text-sm text-gray-900">
                    {item.product_lot}
                  </p>
                </div>
                <div>
                  <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">
                    Expired Date
                  </span>
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {formatDateStandard(item.best_before_date)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
}
